var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _path, _line66, _line67, _path2, _line68, _line69, _line70, _path3, _line71, _path4, _line72, _line73, _path5, _line74, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFefco426 = function SvgFefco426(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400.0mm",
    height: "604.5mm",
    viewBox: "0.0 0.0 400.0 604.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 98.75,
    x2: 0,
    y1: 493,
    y2: 493,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 401,
    y2: 493,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 0,
    y1: 401,
    y2: 401,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 99.75,
    x2: 100,
    y1: 401.5,
    y2: 401,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 99.75,
    x2: 99.75,
    y1: 501.5,
    y2: 401.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 99.25,
    x2: 99.75,
    y1: 493,
    y2: 493,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 98.75,
    x2: 99.25,
    y1: 493,
    y2: 493,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 100.25,
    x2: 99.75,
    y1: 502.5,
    y2: 501.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 100.25,
    x2: 100.25,
    y1: 602.5,
    y2: 502.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 139.85000000000002,
    x2: 100.25,
    y1: 602.5,
    y2: 602.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 140.35000000000002,
    x2: 139.85000000000002,
    y1: 604.5,
    y2: 602.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 179.45,
    x2: 140.35000000000002,
    y1: 604.5,
    y2: 604.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 179.95,
    x2: 179.45,
    y1: 602.5,
    y2: 604.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 220.05,
    x2: 179.95,
    y1: 602.5,
    y2: 602.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 220.55,
    x2: 220.05,
    y1: 604.5,
    y2: 602.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 260.15000000000003,
    x2: 259.65000000000003,
    y1: 602.5,
    y2: 604.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 220.55,
    x2: 259.65000000000003,
    y1: 604.5,
    y2: 604.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 300.25,
    x2: 299.75,
    y1: 501.5,
    y2: 502.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 299.75,
    x2: 299.75,
    y1: 602.5,
    y2: 502.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 260.15000000000003,
    x2: 299.75,
    y1: 602.5,
    y2: 602.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 299.75,
    x2: 100.25,
    y1: 502.5,
    y2: 502.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 99.75,
    x2: 139.85000000000002,
    y1: 401.5,
    y2: 401.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 99.75,
    x2: 300.25,
    y1: 501.5,
    y2: 501.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 179.95,
    x2: 220.05,
    y1: 401.5,
    y2: 401.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 300.25,
    x2: 260.15000000000003,
    y1: 401.5,
    y2: 401.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    x2: 300.25,
    y1: 401,
    y2: 401.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 300.25,
    x2: 300.25,
    y1: 501.5,
    y2: 401.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    x2: 300,
    y1: 401,
    y2: 401,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 301.75,
    x2: 400,
    y1: 493,
    y2: 493,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    x2: 400,
    y1: 401,
    y2: 493,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 300.75,
    x2: 300.25,
    y1: 493,
    y2: 493,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 301.75,
    x2: 300.75,
    y1: 493,
    y2: 493,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    x2: 400,
    y1: 301,
    y2: 401,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    x2: 300,
    y1: 401,
    y2: 301,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    x2: 300,
    y1: 301,
    y2: 301,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 300.25,
    x2: 300.25,
    y1: 200.5,
    y2: 300.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    x2: 300.25,
    y1: 301,
    y2: 300.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    x2: 400,
    y1: 209,
    y2: 301,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 300.25,
    x2: 400,
    y1: 209,
    y2: 209,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 299.5,
    x2: 300.25,
    y1: 199.25,
    y2: 200.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 300.25,
    x2: 99.75,
    y1: 300.5,
    y2: 300.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 99.75,
    x2: 300.25,
    y1: 200.5,
    y2: 200.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 401,
    y2: 301,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 209,
    y2: 301,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 99.75,
    y1: 301,
    y2: 300.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 100,
    y1: 301,
    y2: 301,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    x2: 100,
    y1: 401,
    y2: 301,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 99.75,
    x2: 99.75,
    y1: 300.5,
    y2: 200.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 99.75,
    y1: 209,
    y2: 209,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 100.5,
    x2: 99.75,
    y1: 199.25,
    y2: 200.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 100.75,
    x2: 299.25,
    y1: 100,
    y2: 100,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 100.5,
    x2: 100.5,
    y1: 100.5,
    y2: 100,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 100.75,
    x2: 100.5,
    y1: 100,
    y2: 100,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 100.5,
    x2: 100.5,
    y1: 100.5,
    y2: 199.25,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 299.5,
    x2: 299.5,
    y1: 199.25,
    y2: 100.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 299.25,
    x2: 299.5,
    y1: 100,
    y2: 100,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 299.5,
    x2: 299.5,
    y1: 100.5,
    y2: 100,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 220.05,
    x2: 260.15000000000003,
    y1: 401.5,
    y2: 401.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 220.05,
    x2: 260.15000000000003,
    y1: 400,
    y2: 400,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 260.15000000000003,
    x2: 260.15000000000003,
    y1: 401.5,
    y2: 400,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 220.05,
    x2: 220.05,
    y1: 400,
    y2: 401.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 139.85000000000002,
    x2: 179.95,
    y1: 400,
    y2: 400,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 179.95,
    x2: 179.95,
    y1: 401.5,
    y2: 400,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 139.85000000000002,
    x2: 139.85000000000002,
    y1: 400,
    y2: 401.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 139.85000000000002,
    x2: 179.95,
    y1: 401.5,
    y2: 401.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 299.25 29.5 c 0 -14.75 -14.75 -29.5 -29.5 -29.5"
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 299.25,
    x2: 299.25,
    y1: 100,
    y2: 29.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 100.75,
    x2: 100.75,
    y1: 100,
    y2: 29.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 100.75 29.5 c 0 -14.75 14.75 -29.5 29.5 -29.5"
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 130.25,
    x2: 269.75,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 100.5,
    x2: 30.5,
    y1: 100.5,
    y2: 114.6,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    x2: 1,
    y1: 150,
    y2: 169.75,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 1 169.75 c 0 14.75 14.75 29.5 29.5 29.5"
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    x1: 100.5,
    x2: 30.5,
    y1: 199.25,
    y2: 199.25,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 1 150 C 1 132.3 8.375 121.975 30.5 114.6"
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    x1: 299.5,
    x2: 369.5,
    y1: 199.25,
    y2: 199.25,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    x1: 399,
    x2: 399,
    y1: 169.75,
    y2: 150,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 399 150 C 399 132.3 391.625 121.975 369.5 114.6"
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    x1: 299.5,
    x2: 369.5,
    y1: 100.5,
    y2: 114.6,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 399 169.75 c 0 14.75 -14.75 29.5 -29.5 29.5"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFefco426, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fefco-426.6383f7fb.svg";
export { ForwardRef as ReactComponent };